import { keepPreviousData, QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 0,
      placeholderData: keepPreviousData,
    },
    mutations: {
      retry: 0,
    },
  },
})

export default queryClient
